import { render, staticRenderFns } from "./UserViewDetails.vue?vue&type=template&id=47311c70&"
import script from "./UserViewDetails.vue?vue&type=script&lang=js&"
export * from "./UserViewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports